"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllRequiredConsentCollected = exports.getAllStagedRequiredConsentCollected = exports.getLegitimateInterestConfirmed = exports.getLegalConsentResponses = exports.getStagedLegalConsentResponses = void 0;

var _get = _interopRequireDefault(require("transmute/get"));

var _reselect = require("reselect");

var _BookInfoSelectors = require("./BookInfoSelectors");

var getStagedLegalConsentResponses = (0, _get.default)('stagedLegalConsentResponses');
exports.getStagedLegalConsentResponses = getStagedLegalConsentResponses;
var getLegalConsentResponses = (0, _get.default)('legalConsentResponses');
exports.getLegalConsentResponses = getLegalConsentResponses;
var getLegitimateInterestConfirmed = (0, _get.default)('legitimateInterestConfirmed');
exports.getLegitimateInterestConfirmed = getLegitimateInterestConfirmed;

var allRequiredResponsesCollected = function allRequiredResponsesCollected(consentResponses) {
  if (!consentResponses) {
    return false;
  }

  return consentResponses.filter(function (response) {
    return response.required;
  }).every(function (requiredResponse) {
    return requiredResponse.consented;
  });
};

var getAllStagedRequiredConsentCollected = (0, _reselect.createSelector)([getStagedLegalConsentResponses], allRequiredResponsesCollected);
exports.getAllStagedRequiredConsentCollected = getAllStagedRequiredConsentCollected;
var getAllRequiredConsentCollected = (0, _reselect.createSelector)([_BookInfoSelectors.getLegalConsentEnabled, _BookInfoSelectors.getIsLegitimateInterest, getLegitimateInterestConfirmed, getLegalConsentResponses], function (legalConsentEnabled, isLegitimateInterest, legitimateInterestConfirmed, consentResponses) {
  return !legalConsentEnabled || (isLegitimateInterest ? legitimateInterestConfirmed : allRequiredResponsesCollected(consentResponses));
});
exports.getAllRequiredConsentCollected = getAllRequiredConsentCollected;